import React from 'react';

import { getAssetTitle, joinClassNames } from '../../utils';
import { Lightbox } from '../Lightbox/Lightbox';

import './gallery-item.css';

const ExternalLink = ({ href, children }) => (
  <a
    className="rnftg-no-underline rnftg-text-black dark:rnftg-text-gray-200"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);


export const GalleryItem = ({
  asset,
  index,
  metadataIsVisible,
  hasLightbox,
  setLightboxIndex,
  increaseLightboxIndex,
  decreaseLightboxIndex,
  hasExternalLinks,
  itemContainerStyle,
  imgContainerStyle,
}) => {
  const assetTitle = getAssetTitle(asset);

  const renderAssetMedia = () => {
    // No media present -> render the name/tokenId as a placeholder.
    if (!asset.image_preview_url) {
      return (
        <div
          className={joinClassNames(
            'rnftg-flex rnftg-flex-col rnftg-justify-center rnftg-items-center rnftg-w-full rnftg-h-full rnftg-cursor-pointer',
            'rnftg-break-words rnftg-truncate rnftg-text-lg rnftg-font-semibold dark:rnftg-text-gray-200'
          )}
        >
          {assetTitle}
        </div>
      );
    }

    // const assetMediaExt = asset.image_preview_url.split('.').pop();
    // if (assetMediaExt === 'mp4') {
    //   return (
    //     <video
    //       className={joinClassNames(
    //         'rnftg-w-full rnftg-h-full rnftg-object-cover rnftg-cursor-pointer',
    //         metadataIsVisible ? 'rnftg-rounded-t-2xl' : 'rnftg-rounded-2xl'
    //       )}
    //       src={asset.image_preview_url}
    //       preload="auto"
    //       controlsList="nodownload"
    //       autoPlay
    //       loop
    //       playsInline
    //     ></video>
    //   );
    // }

    return (
      <img
        className={joinClassNames(
          'rnftg-w-full rnftg-h-full rnftg-object-cover rnftg-cursor-pointer',
          metadataIsVisible ? 'rnftg-rounded-t-2xl' : 'rnftg-rounded-2xl'
        )}
        src={asset.image_preview_url}
        alt={asset.name}
        loading="lazy"
      />
    );
  };

  return (
    <article
      style={itemContainerStyle}
      className="rnftg-item rnftg-rounded-2xl rnftg-bg-white dark:rnftg-bg-gray-800 rnftg-shadow-lg hover:rnftg-shadow-xl rnftg-transition rnftg-duration-300"
    >
      <div style={imgContainerStyle} className="rnftg-item__img-wrapper">
        <a
          className="rnftg-no-underline rnftg-text-black dark:rnftg-text-gray-200"
          onClick={() => setLightboxIndex(index)}
          href={`#lightbox-${index}`}
        >
          {renderAssetMedia()}
        </a>
      </div>

      {/*Collection Data*/}
      {metadataIsVisible && (
        <div className="rnftg-p-4">
          <div className="rnftg-break-words rnftg-truncate rnftg-text-lg rnftg-font-semibold dark:rnftg-text-gray-200">
            {hasExternalLinks ? (
              <ExternalLink href={asset.creator}>{assetTitle}</ExternalLink>
            ) : (
              assetTitle
            )}
          </div>
          <hr className="rnftg-mx-2 rnftg-my-4 rnftg-border-gray-100 dark:rnftg-border-gray-900" />
          <div className="rnftg-flex rnftg-items-center">
            {asset.pfp ? (

              <img
                src={asset.pfp}
                alt="CIS 233 Student"
                className="rnftg-w-8 rnftg-h-8 rnftg-mr-2 rnftg-rounded-full"
              />
            ) :
              <img
                src="https://www.clipartmax.com/png/small/202-2020897_upenn-women-rugby-university-of-pennsylvania-logo-png.png"
                alt="CIS 233 Student"
                className="rnftg-w-8 rnftg-h-8 rnftg-mr-2 rnftg-rounded-full"
              />}
            <div className="rnftg-text-sm rnftg-font-semibold rnftg-truncate dark:rnftg-text-gray-200">

              <h3>
                {asset.collection.name}
              </h3>

            </div>
          </div>
        </div>
      )}
      {/*Collection Data END*/}


      {hasLightbox && (
        <Lightbox
          index={index}
          asset={asset}
          increaseLightboxIndex={increaseLightboxIndex}
          decreaseLightboxIndex={decreaseLightboxIndex}
        />
      )}
    </article>
  );
};
